import type { Element } from 'slate';

import { useSlateStatic } from 'slate-react';

import classes from '@ui/MarkdownEditor/style.module.scss';

import { useIsWholeBlockSelected } from './hooks/useIsWholeBlockSelected';

const useSelectedClassName = (element: Element) => {
  const editor = useSlateStatic();
  const className = useIsWholeBlockSelected(editor, element) ? classes.selected : null;

  return className;
};

export default useSelectedClassName;
